<template>
    <v-container>
        <v-row>
            <v-col>
                <v-toolbar dense elevation="1" color="secondary" rounded>
                    <v-breadcrumbs class="ms-n6" :items="[{text: 'Purchasing & Ordering'}, {text: 'Ordering'} ,{text: 'Supplier Group List',}]" large/>
                </v-toolbar>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-sheet elevation="1" rounded>
                    <v-toolbar flat color="secondary">
                        <v-toolbar-title>
                            Supplier Group
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-items>
                            
                            <PIconBtn icon="mdi-refresh" tooltip="Refresh" @click="search"/>
                            <v-menu offset-y :close-on-content-click="false">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        color="primary"
                                        v-bind="attrs"
                                        v-on="on"
                                        icon
                                        >
                                        <v-icon>mdi-magnify</v-icon>
                                    </v-btn>
                                </template>
                                <v-card 
                                    flat
                                    >
                                    <v-card-title>Search</v-card-title>
                                    <v-card-text>
                                        <SupplierGroupListSearch ref="form"/>
                                    </v-card-text>
                                    <v-card-actions>
                                        <v-btn  color="primary" block @click="$refs.form.submit()">Submit</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-menu>
                            <v-btn depressed color="primary" @click="handleNewSupplier" v-if="hasPermission(perm.supplier_group.create)">
                                <v-icon left>mdi-plus</v-icon>
                                New Group
                            </v-btn>
                        </v-toolbar-items>
                    </v-toolbar>
                    <v-divider></v-divider>
                    <SupplierGroupList/>
                </v-sheet>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import permissions from './../../data/permissions';
import SupplierGroupListSearch from './../../components/purchase/SupplierGroupListSearch.vue'
import SupplierGroupList from './../../components/purchase/SupplierGroupList.vue'
import PIconBtn from './../../components/common/PIconBtn.vue';
import { mapActions, mapGetters } from 'vuex';

export default {
    name: "SupplierGroupListView",
    components: {
        PIconBtn,
        SupplierGroupList,
        SupplierGroupListSearch
    },
    data() {
        return {
            perm: permissions
        }
    },
    computed: {
        ...mapGetters({
            hasPermission: "authentication/hasPermission"
        })
    },
    methods: {
        handleNewSupplier() {
            this.$router.push({ name: "SupplierGroupCreate"})
        },
        ...mapActions({
            search: "purchase/supplierGroup/list/search"
        }),
    }
}
</script>

<style>

</style>